import type { FestivalConfig } from "./types";

// A review checks the linked organiser page, not every historical claim in a
// legacy entry. New confirmed editions carry their own date evidence.
export const FESTIVAL_REVIEWS: Record<string, Partial<FestivalConfig>> = {
  "reading-leeds": {
    "website": "https://www.readingfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.readingfestival.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-26",
        "end": "2027-08-29",
        "sourceUrl": "https://www.readingfestival.com/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "boomtown": {
    "website": "https://www.boomtownfair.co.uk/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.boomtownfair.co.uk/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-11",
        "end": "2027-08-15",
        "sourceUrl": "https://www.boomtownfair.co.uk/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "download": {
    "website": "https://downloadfestival.co.uk/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://downloadfestival.co.uk/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-09",
        "end": "2027-06-13",
        "sourceUrl": "https://downloadfestival.co.uk/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "parklife": {
    "website": "https://parklife.uk.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://parklife.uk.com/",
      "note": "The organiser now names July 2027. Exact days have not been verified; the entire month is a planning window, not a scheduled event."
    },
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 1,
      "monthEnd": 7,
      "dayEnd": 31
    }
  },
  "boardmasters": {
    "website": "https://boardmasters.com/book-tickets-2027/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://boardmasters.com/book-tickets-2027/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "latitude": {
    "website": "https://www.latitudefestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.latitudefestival.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-22",
        "end": "2027-07-25",
        "sourceUrl": "https://www.latitudefestival.com/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "creamfields": {
    "website": "https://creamfields.com/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://creamfields.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-26",
        "end": "2027-08-29",
        "sourceUrl": "https://creamfields.com/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "isle-of-wight": {
    "website": "https://isleofwightfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://isleofwightfestival.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-17",
        "end": "2027-06-20",
        "sourceUrl": "https://isleofwightfestival.com/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "all-points-east": {
    "website": "https://www.allpointseastfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.allpointseastfestival.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "green-man": {
    "website": "https://www.greenman.net/information/faqs/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.greenman.net/information/faqs/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-19",
        "end": "2027-08-22",
        "sourceUrl": "https://www.greenman.net/information/faqs/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "shambala": {
    "website": "https://www.shambalafestival.org/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.shambalafestival.org/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "wireless": {
    "website": "https://www.wirelessfestival.co.uk/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.wirelessfestival.co.uk/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "trnsmt": {
    "website": "https://trnsmtfest.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://trnsmtfest.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "end-of-the-road": {
    "website": "https://endoftheroadfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://endoftheroadfestival.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "labyrinth-on-the-thames": {
    "website": "https://www.labyrinthevents.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.labyrinthevents.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "labyrinth-tofte-manor": {
    "website": "https://www.labyrinthevents.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.labyrinthevents.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "tomorrowland": {
    "website": "https://belgium.tomorrowland.com/en/welcome/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://belgium.tomorrowland.com/en/welcome/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "sziget": {
    "website": "https://szigetfestival.com/en/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://szigetfestival.com/en/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-10",
        "end": "2027-08-14",
        "sourceUrl": "https://szigetfestival.com/en/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "primavera-sound": {
    "website": "https://www.primaverasound.com/en/barcelona",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.primaverasound.com/pt?pass=1"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-03",
        "end": "2027-06-05",
        "sourceUrl": "https://www.primaverasound.com/pt?pass=1",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "roskilde": {
    "website": "https://www.roskilde-festival.dk/en",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.roskilde-festival.dk/en"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-26",
        "end": "2027-07-03",
        "sourceUrl": "https://www.roskilde-festival.dk/en",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "rock-werchter": {
    "website": "https://www.rockwerchter.be/en/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.rockwerchter.be/en/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-01",
        "end": "2027-07-04",
        "sourceUrl": "https://www.rockwerchter.be/en/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "mysteryland": {
    "website": "https://www.mysteryland.nl/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.mysteryland.nl/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    },
    "excludedYears": [
      {
        "year": 2026,
        "reason": "The organiser announced a break in 2026 and plans to return in 2027.",
        "sourceUrl": "https://www.mysteryland.nl/?direct=true"
      }
    ]
  },
  "awakenings": {
    "website": "https://www.awakenings.com/en/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.awakenings.com/en/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-09",
        "end": "2027-07-11",
        "sourceUrl": "https://www.awakenings.com/en/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "hellfest": {
    "website": "https://hellfest.fr/en/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://hellfest.fr/en/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-17",
        "end": "2027-06-20",
        "sourceUrl": "https://hellfest.fr/en/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "oya": {
    "website": "https://www.oyafestivalen.no/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.oyafestivalen.no/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "lowlands": {
    "website": "https://lowlands.nl/feed",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://lowlands.nl/feed"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-20",
        "end": "2027-08-22",
        "sourceUrl": "https://lowlands.nl/feed",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "coachella": {
    "website": "https://hospitality.coachella.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://hospitality.coachella.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-04-09",
        "end": "2027-04-18",
        "sourceUrl": "https://hospitality.coachella.com/",
        "checkedAt": "2026-09-20",
        "weekends": [
          {
            "label": "Weekend 1",
            "start": "2027-04-09",
            "end": "2027-04-11"
          },
          {
            "label": "Weekend 2",
            "start": "2027-04-16",
            "end": "2027-04-18"
          }
        ]
      }
    ]
  },
  "lollapalooza": {
    "website": "https://www.lollapalooza.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.lollapalooza.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "bonnaroo": {
    "website": "https://www.bonnaroo.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.bonnaroo.com/",
      "note": "The organiser has announced a year off in 2027."
    },
    "excludedYears": [
      {
        "year": 2027,
        "reason": "The organiser has announced a year off in 2027.",
        "sourceUrl": "https://www.bonnaroo.com/"
      }
    ]
  },
  "edc-las-vegas": {
    "website": "https://lasvegas.edc.com/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://lasvegas.edc.com/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-05-14",
        "end": "2027-05-23",
        "sourceUrl": "https://lasvegas.edc.com/",
        "checkedAt": "2026-09-20",
        "weekends": [
          {
            "label": "EDC Dusk",
            "start": "2027-05-14",
            "end": "2027-05-16"
          },
          {
            "label": "EDC Dawn",
            "start": "2027-05-21",
            "end": "2027-05-23"
          }
        ]
      }
    ]
  },
  "burning-man": {
    "website": "https://burningman.org/black-rock-city/black-rock-city-2027/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://burningman.org/black-rock-city/black-rock-city-2027/"
    },
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-29",
        "end": "2027-09-06",
        "sourceUrl": "https://burningman.org/black-rock-city/black-rock-city-2027/",
        "checkedAt": "2026-09-20"
      }
    ]
  },
  "governors-ball": {
    "website": "https://www.governorsballmusicfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.governorsballmusicfestival.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "osheaga": {
    "website": "https://osheaga.com/en",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://osheaga.com/en",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "electric-forest": {
    "website": "https://www.electricforest.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.electricforest.com/",
      "note": "Exact dates for the next edition were not verified. Typical timing is labelled Dates TBC."
    }
  },
  "laneway": {
    "website": "https://www.lanewayfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.lanewayfestival.com/",
      "note": "This entry covers Sydney only. Other tour stops need their own dates and locations."
    },
    "name": "Laneway Festival Sydney"
  },
  "splendour": {
    "website": "https://splendourinthegrass.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://splendourinthegrass.com/",
      "note": "A return date has not been confirmed. Check the organiser’s latest announcement for updates."
    },
    "paused": {
      "reason": "The organiser's latest update announces a pause. A return date has not been verified.",
      "sourceUrl": "https://splendourinthegrass.com/"
    },
    "confirmedDates": []
  },
  "beyond-the-valley": {
    "website": "https://www.beyondthevalley.com.au/terms-and-conditions",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.beyondthevalley.com.au/terms-and-conditions"
    },
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-12-28",
        "end": "2026-12-31",
        "sourceUrl": "https://www.beyondthevalley.com.au/terms-and-conditions",
        "checkedAt": "2026-09-20"
      }
    ],
    "city": "Barunah Plains, Victoria",
    "lat": -38.0817,
    "lng": 143.8708,
    "weatherHistoryFromYear": 2026,
    "labelOverrides": undefined,
    "blurb": "A New Year camping festival at Barunah Plains in Victoria. Electronic music, live acts and summer camping across the final days of December."
  },
  "rhythm-vines": {
    "website": "https://www.rhythmandvines.co.nz/tickets",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.rhythmandvines.co.nz/behind-the-vines/rhythm-and-vines-announces-final-festival-at-waiohika-estate",
      "note": "The 2026 event is the last at Waiohika Estate. Future dates and the new venue are awaiting confirmation."
    },
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-12-29",
        "end": "2026-12-31",
        "sourceUrl": "https://www.rhythmandvines.co.nz/tickets",
        "checkedAt": "2026-09-20"
      }
    ],
    "typicalWindow": {
      "monthStart": 12,
      "dayStart": 29,
      "monthEnd": 12,
      "dayEnd": 31
    },
    "confirmedDatesOnly": true
  }
};

export function applyFestivalReview(festival: FestivalConfig): FestivalConfig {
  const review = FESTIVAL_REVIEWS[festival.slug];
  if (!review) return festival;
  const retained = festival.confirmedDates?.filter((date) => !review.confirmedDates?.some((next) => next.year === date.year)) ?? [];
  return {
    ...festival,
    ...review,
    confirmedDates: review.paused ? [] : [...retained, ...(review.confirmedDates ?? [])].sort((a, b) => a.start.localeCompare(b.start)),
  };
}
